import {usePersonalData} from 'presentation/hooks';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {UsePrintTemplateProps} from './types';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

export function usePrintTemplate({bookedAppointment, flowType}: UsePrintTemplateProps) {
	const {userName} = usePersonalData();
	const accountData = useAccountDataStore(state => state.accountData);
	const isTelehealth = flowType === FlowEnum.TELEHEALTH;
	const isExam = flowType === FlowEnum.EXAM;

	const {
		clinicName,
		hour,
		dateOnly,
		providerName,
		specialtyName,
		protocolNumber,
		formattedAddress,
	} = bookedAppointment;

	const beneficiaryName = userName;
	const planName = accountData.beneficiary.nmPlano;

	const hideAddress = isTelehealth;
	const hideDocumentAlert = isTelehealth || isExam;

	return {
		clinicName,
		hour,
		providerName,
		specialtyName,
		protocolNumber,
		date: dateOnly,
		planName,
		beneficiaryName,
		formattedAddress,
		hideAddress,
		hideDocumentAlert,
	};
}
